/**
 * web/src/screens/Notebook/tabs.ts — Notebook's collection row, declared once
 * (card 8hGV3kwDaVoB).
 *
 * The row is ENTRY_TILES (the seven collection views, in order) plus Vault.
 * Explore builds its Notebook rows from THIS array, so the two lists cannot
 * drift again. Vault carries `explore: false`: it left the drawer in card
 * 3YypYdChpTZD (founder email 2026-10-31) because it is a tab inside
 * Notebook, and a second door in Explore only split the same room in two.
 * That decision now lives on the tab definition, where the tab is declared.
 */
import type { SubTabDef } from '../../components/SubTabs';
import { ENTRY_TILES } from './types';

export const NB_TABS: SubTabDef[] = [
  ...ENTRY_TILES.map(t => ({ key: t.key as string, label: t.label })),
  { key: 'vault', label: 'Vault', explore: false },
];
